import * as React from 'react';

import { createIcon } from '../Icon';
export const ArrowUpLeftIcon = createIcon(
  <React.Fragment>
    <line x1={17} y1={17} x2={7} y2={7} />
    <polyline points="7 17 7 7 17 7" />
  </React.Fragment>,
  'ArrowUpLeftIcon'
);
